import { render } from "./ed-organism-jumbo-block.vue?vue&type=template&id=bb1c8b94"
import script from "./ed-organism-jumbo-block.vue?vue&type=script&lang=js"
export * from "./ed-organism-jumbo-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__